import z from "zod/v4";

import { PerformanceModelSchema } from "./performance-model";

export const PerformanceByColorSchema = z.object({
    white: z.object({
        total: PerformanceModelSchema,
        rated: PerformanceModelSchema,
    }),
    black: z.object({
        total: PerformanceModelSchema,
        rated: PerformanceModelSchema,
    }),
});

export type PerformanceByColor = z.infer<typeof PerformanceByColorSchema>;
